/**
 * eg:
 * lng('Modal.confirm')
 * lng('DatePicker.Month.jan')
*/
import { cloneJSON } from '@utiljs/clone';
import defaultLang from './lang/zh-CN';
var _lang = defaultLang;

var use = function use(lang) {
  _lang = lang;
};

var lng = function lng(path) {
  var value = cloneJSON(_lang);
  var arr = path.split('.');
  arr.forEach(function (i) {
    // @ts-ignore
    value = value[i];
  });
  return value || '';
};

export default {
  use: use,
  lng: lng
};